/**
 * Default > Components
 */

import Button from '../../shared/components/button';
import Details from '../../shared/components/details';
import TabGroup from '../../shared/components/tab-group';
import Slider from './shared/slider';
import Form from './shared/form';
import List from '../../shared/components/list';
import Player from '../../shared/components/player';
import Tag from '../../shared/components/tag';
import Table from './shared/table';

// ------
// Public
// ------

const components = () => {
	Button.init();
	Details.init();
	TabGroup.init(null, {
		showIndicator: false
	});
	Slider();
	Form();
	List.init();
	Player.init();
	Tag.init();
	Table.makeScrollable();
};

// Export
export default components;
